// extracted by mini-css-extract-plugin
export default {"wrapper":"Su8b5w","wrapperVisuallyHidden":"ENEdLy","icon":"qIrqpl","postTextIcon":"be_mZV","croutonArrow":"c1KsAg"};